import ApiService from './ApiService';
import Constant from '../util/Constant';
import { getUniqueReferenceId } from '../util/Generator';
import format from 'date-fns/format';
import parse from 'date-fns/parse';

class VendingService {
   /**
    *
    * @param {*} encoded
    */
   static getHeaders(encoded) {
      let headers = {
         'Content-Type': 'text/xml',
         'Authorization': `Basic ${encoded}`,
      };
      return headers;
   }
   /**
    *
    * @param {*} requestData
    */
   static validateMeter(requestData) {
      let encoded = JSON.parse(sessionStorage.getItem('user')).encoded;
      let url = `${Constant.URL}/AgentMeterValidation`;
      let request = `<?xml version="1.0" encoding="UTF-8"?>
                  <metervalidationrequest>
                  <partenerid>${requestData.partnerId}</partenerid>
                  <referenceid>${getUniqueReferenceId(requestData.partnerId)}</referenceid>
                  <meternumber>${requestData.meterNumber}</meternumber>
                  <mobilenumber>${requestData.mobileNumber}</mobilenumber>
                  <purchaseamount>${requestData.amount}</purchaseamount>
                  </metervalidationrequest>`;
      return ApiService.postData(url, VendingService.getHeaders(encoded), request);
   }
   /**
    *
    * @param {*} requestData
    */
   static vendElectricity(requestData) {
      let encoded = JSON.parse(sessionStorage.getItem('user')).encoded;
      let url = `${Constant.URL}/AgentVending`;
      let request = `<?xml version="1.0" encoding="UTF-8"?>
                        <vendingrequest>
                              <partenerid>${requestData.partnerId}</partenerid>
                              <referenceid>${getUniqueReferenceId(
                                 requestData.partnerId
                              )}</referenceid>
                              <meternumber>${requestData.meterNumber}</meternumber>
                              <purchaseamount>${requestData.amount}</purchaseamount>
                              <language>2</language>
                              <mobilenumber>${requestData.mobileNumber}</mobilenumber>
                              <requesttime>${format(
                                 new Date(),
                                 "yyyy-MM-dd'T'HH:mm:ss"
                              )}</requesttime>
                           </vendingrequest>`;
      return ApiService.postData(url, VendingService.getHeaders(encoded), request);
   }
   /**
    *
    * @param {*} requestData
    */
   static getSalesSummary(requestData) {
      let encoded = JSON.parse(sessionStorage.getItem('user')).encoded;
      let url = `${Constant.URL}/AgentVendingSummary`;
      let request = `<?xml version="1.0" encoding="UTF-8"?>
                     <vendingsummaryrequest>
                     <partenerid>${requestData.partnerId}</partenerid>
                     <referenceid>${getUniqueReferenceId(requestData.partnerId)}</referenceid>
                     <requesttime>${format(new Date(), "yyyy-MM-dd'T'HH:mm:ss")}</requesttime>
                     </vendingsummaryrequest>`;
      return ApiService.postData(url, VendingService.getHeaders(encoded), request);
   }
   /**
    *
    * @param {*} requestData
    */
   static getSalesHistory(requestData) {
      let encoded = JSON.parse(sessionStorage.getItem('user')).encoded;
      let url = `${Constant.URL}/AgentVendingHistory`;

      let strEndDate = format(requestData.endDate, 'yyyy-MM-dd') + 'T23:59:59';
      let strStartDate = format(requestData.startDate, 'yyyy-MM-dd') + 'T00:00:00';

      let resultedEndDate = parse(strEndDate, "yyyy-MM-dd'T'HH:mm:ss", new Date());
      let resultedStartDate = parse(strStartDate, "yyyy-MM-dd'T'HH:mm:ss", new Date());

      let request = `<?xml version="1.0" encoding="UTF-8"?>
                           <vendinghistoryrequest>
                              <partenerid>${requestData.partnerId}</partenerid>
                              <referenceid>${getUniqueReferenceId(
                                 requestData.partnerId
                              )}</referenceid>
                               <requesttime>${format(
                                  new Date(),
                                  "yyyy-MM-dd'T'HH:mm:ss"
                               )}</requesttime>
                              <startdatetime>${format(
                                 resultedStartDate,
                                 "yyyy-MM-dd'T'HH:mm:ss"
                              )}</startdatetime>
                              <enddatetime>${format(
                                 resultedEndDate,
                                 "yyyy-MM-dd'T'HH:mm:ss"
                              )}</enddatetime>
                           </vendinghistoryrequest>`;
      return ApiService.postData(url, VendingService.getHeaders(encoded), request);
   }
   static getReceipt(requestData) {
      let encoded = JSON.parse(sessionStorage.getItem('user')).encoded;
      let url = `${Constant.URL}/AgentReceiptDetails`;
      let request = `<?xml version="1.0" encoding="UTF-8"?>
                     <vendingreceiptrequest>
                     <partenerid>${requestData.partnerId}</partenerid>
                     <referenceid>${getUniqueReferenceId(requestData.partnerId)}</referenceid>
                     <transactionid>${requestData.transactionId}</transactionid>
                     </vendingreceiptrequest>`;
      return ApiService.postData(url, VendingService.getHeaders(encoded), request);
   }
   static getReceiptWithoutLogin(requestData) {
      let encoded = 'dmVuZG9ydGVzdDI6VmVuZG9yMkAzMTgw';
      let url = `${Constant.URL}/AgentReceiptReprint`;
      let request = `<?xml version="1.0" encoding="UTF-8"?>
                     <vendingreceiptrequest>
                     <partenerid>${requestData.partnerId}</partenerid>
                     <referenceid>${getUniqueReferenceId(requestData.partnerId)}</referenceid>
                     <transactionid>${requestData.transactionId}</transactionid>
                     </vendingreceiptrequest>`;
      return ApiService.postData(url, VendingService.getHeaders(encoded), request);
   }

   static sendSmsReceipt(requestData) {
      console.log(requestData);
      let encoded = JSON.parse(sessionStorage.getItem('user')).encoded;
      let url = `${Constant.URL}/AgentSendReceiptSms`;
      let request = `<?xml version="1.0" encoding="UTF-8"?>
                     <vendingsendreceiptsms>
                     <partenerid>${requestData.partnerId}</partenerid>
                     <referenceid>${getUniqueReferenceId(requestData.partnerId)}</referenceid>
                     <msisdn>${requestData.msisdn}</msisdn>
                     <transactionid>${requestData.transactionId}</transactionid>
                     </vendingsendreceiptsms>`;
      return ApiService.postData(url, VendingService.getHeaders(encoded), request);
   }

   static sendEmailReceipt(requestData) {
      let encoded = JSON.parse(sessionStorage.getItem('user')).encoded;
      let url = `${Constant.URL}/AgentSendReceiptEmail`;
      let request = `<?xml version="1.0" encoding="UTF-8"?>
                     <vendingsendreceiptemail>
                     <partenerid>${requestData.partnerId}</partenerid>
                     <referenceid>${getUniqueReferenceId(requestData.partnerId)}</referenceid>
                     <receiveremail>${requestData.email}</receiveremail>
                     <transactionid>${requestData.transactionId}</transactionid>
                     </vendingsendreceiptemail>`;
      return ApiService.postData(url, VendingService.getHeaders(encoded), request);
   }

   static vendAirtime(requestData) {
      let encoded = JSON.parse(sessionStorage.getItem('user')).encoded;
      return ApiService.postData(Constant.URL, VendingService.getHeaders(encoded), requestData);
   }
}

export default VendingService;
